import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import {
  WoundApprovalItemDto,
  GetWoundAssignDoctorDto,
} from 'app/core/models/wound/wound.model';
import { WoundService } from 'app/core/services/wound/wound.service';
import { UserService } from 'app/core/services/user/user.service';
import { CurrentUserService } from 'app/core/services/auth/current-user.service';
import { SelectComponent } from 'app/shared/components/select/select.component';

@Component({
  selector: 'app-doctor-assign-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule, SelectComponent],
  templateUrl: './doctor-assign-modal.component.html',
  styleUrl: './doctor-assign-modal.component.scss',
})
export class DoctorAssignModalComponent implements OnInit {
  selectedDoctorId: string | null = null;
  selectedDoctorName: string | null = null;
  woundId: string | null = null;
  consultationId: string | null = null;
  organizationId: string | undefined;
  WoundForApproveDto: WoundApprovalItemDto;

  constructor(
    private woundService: WoundService,
    private userService: UserService,
    private currentUserService: CurrentUserService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.loadDoctors();
  }

  loadDoctors() {
    if (this.organizationId) {
      this.userService
        .getListUserByRoleType(4, this.organizationId)
        .subscribe((res) => {
          if (res.isSuccess) {
            const doctors = res.data.map((u: any) => ({
              doctorId: u.id,
              doctorName: u.name,
            })) as GetWoundAssignDoctorDto[];

            if (!this.WoundForApproveDto) {
              this.WoundForApproveDto = {
                wound: {
                  assignDoctors: doctors,
                } as any,
              } as any;
            } else {
              this.WoundForApproveDto.wound.assignDoctors = doctors;
            }
          }
        });
    } else {
      this.woundService
        .getWoundForApproveByWoundId(this.woundId)
        .subscribe((res) => {
          this.WoundForApproveDto = res.data;
        });
    }
  }

  selectDoctor(doctorId: string, doctorName: string) {
    this.selectedDoctorId = doctorId;
    this.selectedDoctorName = doctorName;
  }

  onDoctorSelectChange(event: any) {
    const selectedId = (event.target as HTMLSelectElement).value;
    const doctor = this.WoundForApproveDto?.wound?.assignDoctors.find(
      (d) => d.doctorId === selectedId
    );
    if (doctor) {
      this.selectedDoctorName = doctor.doctorName;
    }
  }

  assignDoctor() {
    if (!this.selectedDoctorId) return;

    if (this.consultationId) {
      const body = {
        consultationId: this.consultationId,
        isNeedApprove: false,
        doctorId: this.selectedDoctorId,
        doctorName: this.selectedDoctorName,
      };

      this.woundService
        .assignWoundConsultationToDoctor(body)
        .subscribe((res) => {
          if (res.isSuccess) {
            this.activeModal.close();
          }
        });
      return;
    }

    if (this.organizationId) {
      // System Admin Logic (Assign)
      // When assigning via system_admin_claim, isNeedApprove should be false (user request)
      const body = {
        woundId: String(this.woundId),
        isNeedApprove: false,
        doctorId: this.selectedDoctorId,
        doctorName: this.selectedDoctorName,
      };

      this.woundService.assignWoundToDoctor(body).subscribe((res) => {
        if (res.isSuccess) {
          this.activeModal.close();
        }
      });
    } else {
      // Facility Admin Logic (Claim/Approve)
      this.woundService
        .approveWound({
          woundIds: [this.woundId],
          doctorId: this.selectedDoctorId,
          doctorName: this.selectedDoctorName,
        })
        .subscribe((res) => {
          if (res.isSuccess) {
            this.activeModal.close();
          }
        });
    }
  }
}
